import {
  reelsConfirmAndPayEvent,
  reelsTikTokNotNow,
  reelsTikTokTried,
} from 'src/Helpers/TagManager/ReelsEvents'
import { getUserId } from 'src/Redux/auth-process/userSlice/selectors'
import { getScheduledTikTokCampaign } from 'src/Redux/schedule-process/tiktokCampaign/selectors'
import { getTiktokPrice } from 'src/Redux/schedule-process/audienceTiktokSlice/selectors'
import { getPaymentMethod } from 'src/Redux/payment-process/selectors'

import { useAppSelector } from '../redux'

interface UseReelsEvents {
  onReelsConfirmEvent: () => void
  onReelsTikTokTried: () => void
  onReelsTikTokNotNow: () => void
}

export const useReelsEvents = (): UseReelsEvents => {
  const userId = useAppSelector(getUserId)
  const scheduledCampaign = useAppSelector(getScheduledTikTokCampaign)
  const tikTokCampaignPrice = useAppSelector(getTiktokPrice)
  const paymentMethod = useAppSelector(getPaymentMethod)

  const onReelsConfirmEvent = (): void => {
    reelsConfirmAndPayEvent({
      userId,
      paymentMethod,
      campaignId: Number(scheduledCampaign.id),
      price: tikTokCampaignPrice,
    })
  }

  const onReelsTikTokTried = (): void => {
    reelsTikTokTried({
      userId,
      paymentMethod,
      campaignId: Number(scheduledCampaign.id),
      price: tikTokCampaignPrice,
    })
  }

  const onReelsTikTokNotNow = (): void => {
    reelsTikTokNotNow({
      userId,
      paymentMethod,
      campaignId: Number(scheduledCampaign.id),
      price: tikTokCampaignPrice,
    })
  }

  return {
    onReelsConfirmEvent,
    onReelsTikTokTried,
    onReelsTikTokNotNow,
  }
}
